export const financialAidsEn = {
  title: "Financial aid",
  subtitle: "Financial aid to support you in this course of action.",
  loading: "Loading…",
  error: "An error occurred.",
  retry: "Retry",
  types: {
    grant: "Grant",
    loan: "Loan",
    tax_credit: "Tax credit",
    guarantee: "Loan guarantee",
    other: "Other",
  },
  directory: {
    heading: "Financial aid",
    help: "Financial aid offered for this course of action.",
    resultCount_one: "{{count}} aid",
    resultCount_other: "{{count}} aids",
    favoriteCount_one: "{{count}} favorite",
    favoriteCount_other: "{{count}} favorites",
    seeMore_one: "See {{count}} more aid",
    seeMore_other: "See {{count}} more aids",
    none: "No financial aid is available yet for this course of action.",
    noneFiltered: "No financial aid matches the selected filters.",
    noFavorites:
      "You don't have a favorite financial aid for this course of action yet.",
    seeAll: "See all financial aid",
    unavailable: "Financial aid is not available for this course of action.",
    actionRequired: {
      title: "Select a course of action",
      help: "Financial aid is consulted from a course of action in your action plan.",
      goToPlans: "Go to the action plan",
    },
  },
  card: {
    viewSheet: "View details",
    upTo: "Up to {{amount}}",
    from: "From {{amount}}",
    amountTbd: "Amount to be confirmed",
    until: "Until {{date}}",
    fromDate: "From {{date}}",
    always: "At all times",
    favorite: "Add to favorites",
    unfavorite: "Remove from favorites",
  },
  detail: {
    title: "Financial aid details",
    programNumber: "Programme no. {{number}}",
    organization: "Organization",
    fundingTypes: "Funding types",
    amounts: "Amounts offered",
    eligibility: "Eligibility period",
    regions: "Associated regions",
    territories: "Territories covered",
    sectors: "Associated sectors",
    contactPerson: "Contact person",
    contactEmail: "Email",
    contactPhone: "Phone",
    extension: "ext. {{ext}}",
    consult: "View the programme",
  },
  filters: {
    sectorsServed: "Associated sectors",
    companySizes: "Company size",
    orgTypes: "Associated organization types",
    heading: "Filters",
    search: "Title, organization…",
    type: "Funding type",
    regions: "Associated regions",
    minAmount: "Minimum amount",
    maxAmount: "Maximum amount",
    favoritesOnly: "My favorites only",
  },
  cell: {
    all: "View financial aid for this course of action",
    favorites: "View your favourite financial aid for this course of action",
  },
  admin: {
    title: "Financial aid management",
    create: "Create financial aid",
    editAid: "Edit the financial aid",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    empty: "No financial aid.",
    countTotal_one: "{{count}} financial aid in total",
    countTotal_other: "{{count}} financial aids in total",
    linkChangeToValidate: "To validate",
    linkChangePending: "Pending",
    orderToValidate: "Order to validate",
    orderPending: "Order pending",
    import: "Import financial aid",
    importActions: "Import associations",
    importCancelledReviews_one:
      "The import cancelled 1 review in progress: {{titles}}.",
    importCancelledReviews_other:
      "The import cancelled {{count}} reviews in progress: {{titles}}.",
    imported:
      "Import complete: {{created}} created, {{updated}} updated, {{skipped}} skipped.",
    actionsImported:
      "Import complete: {{pairs}} association(s) applied for {{aids}} financial aid.",
    created: "Financial aid created.",
    updated: "Financial aid updated.",
    deleted: "Financial aid deleted.",
    confirmDelete: "Delete this financial aid?",
    history: "History",
    actionCount_one: "{{count}} course of action",
    actionCount_other: "{{count}} courses of action",
    selectAllFundingTypes: "All funding types",
    selectAllTerritories: "All MRCs",
    territoriesUnavailable:
      "The MRC list could not be loaded. The territories already saved are still shown.",
    otherToggle: "Other — please specify",
    // The same columns the Django back-office table sorts on, same wording.
    sort: {
      label: "Sort by",
      default: "Default order",
      title: "Title",
      organization: "Organization",
      eligibility: "Eligibility",
      status: "Status",
      actions: "Courses of action",
      ascending: "Ascending",
      descending: "Descending",
    },
    status: {
      pending: "Pending",
      unassociated: "Not associated",
      inactive: "Inactive",
      expired: "Expired",
      upcoming: "Upcoming",
      active: "Active",
    },
    invalidPhone: "The phone number is invalid.",
    contactPerson: "Contact person",
    contactPersonHint:
      "Person to contact about the programme. Shown on the aid's sheet.",
    fields: {
      title: "Programme title",
      programNumber: "Programme number",
      organization: "Organization",
      fundingTypes: "Funding types",
      amountMin: "Minimum amount",
      amountMax: "Maximum amount",
      amountDescription: "Amount details",
      eligibilityStart: "Eligibility start",
      eligibilityEnd: "Eligibility end",
      contactLastName: "Name",
      contactFirstName: "First name",
      contactFunction: "Function",
      contactEmail: "Email",
      contactPhone: "Business phone number",
      contactExtension: "Extension",
      officialUrl: "Official link",
      summary: "Summary",
      isActive: "Active",
      isInactive: "Inactive",
      territories: "Territories (MRC)",
      territoriesHint:
        "MRCs the aid covers, for the territory ranking. An enterprise is tied to its MRC by its address.",
      territoriesUnknown: "Off catalogue",
      serviceRegions: "Associated regions",
      sectorsServed: "Sectors served",
      companySizes: "Company sizes served",
      organizationTypes: "Eligible organization types",
      serviceRegionsOther: "Other regions covered",
      sectorsServedOther: "Other targeted sectors",
      organizationTypesOther: "Other eligible organization types",
      actions: "Linked courses of action",
    },
  },
  orgTypes: {
    self_employed: "Self-employed worker",
    private: "Private company",
    cooperative: "Cooperative or collective enterprise",
    not_for_profit: "Non-profit organization",
    economical_development: "Economic development organization",
    municipality: "Municipality",
    other: "Other",
  },
  linkOrder: {
    section: "Aid order per course of action",
    sectionHint:
      "Every order change must be validated by another administrator.",
    pending: "Pending",
    toValidate: "To validate",
    open: "Aid order ({{count}})",
    title: "Financial aid order",
    intro:
      "Drag and drop to set the display order. Another administrator will have to validate the change.",
    introMine:
      "You proposed this change. Another administrator must validate it — you cannot validate your own proposal.",
    introReview:
      "Review the proposed order, then approve it or make a counter-proposal.",
    linkChangeWarning:
      "An association change is pending for this course of action: the list may still gain or lose an item.",
    notVisible: "not visible",
    new: "new",
    was: "was {{n}}",
    proposedBy: "Proposed by {{name}}",
    addedSince: "Added since the proposal — placed last",
    note: "Note",
    noteLabel: "Note — required",
    notePlaceholder: "Explain your counter-proposal…",
    propose: "Propose this order",
    approve: "Approve",
    counter: "Counter-propose",
    submitCounter: "Submit counter-proposal",
    close: "Close",
  },
  linkChange: {
    awaiting_one:
      "{{count}} financial aid has a course-of-action change awaiting your validation.",
    awaiting_other:
      "{{count}} financial aids have a course-of-action change awaiting your validation.",
    openReview: "To validate",
    pendingOnly: "Awaiting validation only",
    noneAwaiting: "No change is awaiting validation.",
    reviewTitle: "Financial aid · to validate",
    reviewIntro: "Proposed by other people.",
    reviewIntroOwn: "You cannot validate your own proposals.",
    review: "Review",
    proposedBy: "Proposed by {{name}}",
    note: "Note",
    noteLabel: "Note — required",
    notePlaceholder: "Explain your counter-proposal…",
    noDifference: "No difference detected.",
    count_one: "{{count}} proposal",
    count_other: "{{count}} proposals",
    later: "Later",
    approveAll: "Approve all",
    formPendingMine:
      "You proposed this change. Another administrator must validate it — you cannot validate your own proposal.",
    formPendingReview:
      "Review the proposed change, then approve it or make a counter-proposal.",
    approve: "Approve",
    counter: "Counter-propose",
    cancelCounter: "Cancel the counter-proposal",
    submitCounter: "Submit the counter-proposal",
    saveOthers: "Save the other fields",
    staged:
      "The course-of-action change is awaiting validation by another administrator.",
    frozen:
      "The courses of action were not changed: a change is already awaiting validation.",
    approved: "Course-of-action change approved.",
    countered: "Counter-proposal recorded, awaiting another person.",
    noneToApprove: "No change to approve.",
    approvedCount_one: "{{count}} course-of-action change approved.",
    approvedCount_other: "{{count}} course-of-action changes approved.",
  },
  picker: {
    newLink: "new",
    lockedEmpty:
      "None — the financial aid would no longer have any linked course of action.",
    lockedHint: "Change awaiting validation: the proposed list is shown and cannot be edited.",
    add: "Add courses of action",
    hint:
      "Courses of action linked to this aid, in questionnaire order. The order aid appears in for an enterprise is set per course of action.",
    empty: "No linked course of action yet.",
    remove: "Remove",
    modalTitle: "Add courses of action",
    searchActions: "Search for a course of action…",
    allIssues: "All issues",
    allGoals: "All goals",
    searchIssue: "Search for an issue…",
    searchGoal: "Search for a goal…",
    selectAll: "Select all",
    confirm: "Confirm selection",
    linkedTag: "linked",
    matchCount_one: "{{count}} course of action",
    matchCount_other: "{{count}} courses of action",
    selectedCount_one: "{{count}} selected",
    selectedCount_other: "{{count}} selected",
    noMatch: "No course of action matches.",
  },
};
